<template>
    <div class="page">
        <div class="head-page">
            <div class="member-header p30">
                <el-button class="large-btn" type="primary" @click="addClick()">新增</el-button>
                <el-input placeholder="请输入手机号/姓名/编号查找" v-model="query.mobile" clearable @clear="removeDoQuery" class="input-with-select" prefix-icon="el-icon-search" style="width:600px;height: 40px;">
                    <el-button type="primary" slot="append" style="width: 96px;" @click="rulesMobile">搜索</el-button>
                </el-input>
            </div>
        </div>
        <div class="mains">
            <div class="rows">
                <el-table :data="list" border>
                    <el-table-column prop="customerName" label="姓名"></el-table-column>
                    <el-table-column prop="mobile" label="联系方式" min-width="100px"></el-table-column>
                    <el-table-column prop="cardOldIdCn" label="套餐" min-width="150px"></el-table-column>
                    <el-table-column prop="customerNo" label="编号"></el-table-column>
                    <el-table-column prop="originNum" label="登记次数"></el-table-column>
                    <el-table-column prop="useNum" label="使用次数"></el-table-column>
                    <el-table-column label="创建时间" width="150px">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.oxLtime) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot-scope="scope">
                            <el-link type="primary" class="mr10" @click="addClick(scope.row)">编辑</el-link>
                            <el-link type="primary" @click="detailPage(scope.row)">详情</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <paging :totalCount="totalCount" @doPageQuery="doPageQuery"></paging>
            </div>
        </div>
        <edit-set ref="editSetForm" @change="editChange"></edit-set>
        <detail-set ref="detailSetForm"></detail-set>
    </div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import editSet from './edit'
import detailSet from './detail'
export default {
    mixins: [minxin],
    data () {
        return {
            list: [],
            url: this.$url.cardOld.page,
            query: {
                mobile: '',
            }
        }
    },
    components:{
        editSet,
        detailSet
    },
    created(){
        this.getList();
    },
    methods:{
        addClick(item){
            item == undefined?
            this.$refs['editSetForm'].$emit('set',null):
            this.$refs['editSetForm'].$emit('set',item);
        },
        rulesMobile(){
            if(this.mobile != ''){
                this.list = [];
                this.start = 1;
                this.getList();
            }
        },
        removeDoQuery(){
            this.query = {
                mobile: '',
                start: 1,
                size: 20
            }
            this.getList();
        },
        editChange(bool){
            if(bool){
                this.query = {
                    mobile: '',
                    start: 1,
                    size: 20
                }
                this.getList();
            }
        },
        detailPage(item){
            this.$refs['detailSetForm'].$emit('set',item);
        },
    }
}
</script>

<style scoped lang="less">
@import '../../../assets/css/edit.less';
/deep/ .el-input-group__append{
    background-color: #409EFF;
    color: #fff;
}
/deep/ .input-with-select .el-input__inner{
    height: 56px !important;
}
/deep/ .input-with-select{
    font-size: .18rem;
}
.member-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 60px);
    box-sizing: border-box;
    .title-name{
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-right: 62px;
    }
    .icon-search{ 
        font-size: .3rem;
    }
}
.page-head{
    display: flex;
    padding: 20px 30px;
    .times{
        align-items: center;
        display: flex;
    }
    .flex-row{
        margin-left: 10px;
        align-items: center;
        display: flex;
    }
}
.mains{
    .rows{
        padding: 0 30px 30px;
        // padding-bottom: 0;
        .cols{
            padding-bottom: 40px;
            .van-text{
                font-size: .18rem;
                font-weight: 500;
            }
            .van-label{
                font-size: .2rem;
                color: @red;
                margin-top: 10px;
            }
        }
    }
}
</style>